module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alcohol-sales-container"
  }, [_c('div', {
    staticClass: "filter-section"
  }, [_c('el-card', {
    staticClass: "filter-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "filter-header"
  }, [_c('h3', [_vm._v("酒类产品销售分析报告")]), _vm._v(" "), _c('div', {
    staticClass: "report-type"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeReportType
    },
    model: {
      value: (_vm.reportType),
      callback: function($$v) {
        _vm.reportType = $$v
      },
      expression: "reportType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "year"
    }
  }, [_vm._v("年度报告")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "month"
    }
  }, [_vm._v("月度报告")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "filter-controls"
  }, [_c('div', {
    staticClass: "filter-group"
  }, [(_vm.reportType === 'year') ? _c('label', [_vm._v("选择年份")]) : _c('label', [_vm._v("选择月份")]), _vm._v(" "), (_vm.reportType === 'year') ? _c('el-date-picker', {
    attrs: {
      "type": "year",
      "placeholder": "选择年份",
      "format": "yyyy年",
      "value-format": "yyyy",
      "picker-options": _vm.yearPickerOptions
    },
    on: {
      "change": _vm.handleYearChange
    },
    model: {
      value: (_vm.selectedYear),
      callback: function($$v) {
        _vm.selectedYear = $$v
      },
      expression: "selectedYear"
    }
  }) : _c('el-date-picker', {
    attrs: {
      "type": "month",
      "placeholder": "选择月份",
      "format": "yyyy年MM月",
      "value-format": "yyyy-MM",
      "picker-options": _vm.monthPickerOptions
    },
    on: {
      "change": _vm.handleMonthChange
    },
    model: {
      value: (_vm.selectedMonth),
      callback: function($$v) {
        _vm.selectedMonth = $$v
      },
      expression: "selectedMonth"
    }
  })], 1), _vm._v(" "), (_vm.enableCompare) ? _c('div', {
    staticClass: "filter-group"
  }, [(_vm.reportType === 'year') ? _c('label', [_vm._v("对比年份")]) : _c('label', [_vm._v("对比月份")]), _vm._v(" "), (_vm.reportType === 'year') ? _c('el-date-picker', {
    attrs: {
      "type": "year",
      "placeholder": "选择对比年份",
      "format": "yyyy年",
      "value-format": "yyyy",
      "disabled": !_vm.enableCompare,
      "picker-options": _vm.compareYearPickerOptions
    },
    on: {
      "change": _vm.getCompareData
    },
    model: {
      value: (_vm.compareYear),
      callback: function($$v) {
        _vm.compareYear = $$v
      },
      expression: "compareYear"
    }
  }) : _c('el-date-picker', {
    attrs: {
      "type": "month",
      "placeholder": "选择对比月份",
      "format": "yyyy年MM月",
      "value-format": "yyyy-MM",
      "disabled": !_vm.enableCompare,
      "picker-options": _vm.compareMonthPickerOptions
    },
    on: {
      "change": _vm.getCompareData
    },
    model: {
      value: (_vm.compareMonth),
      callback: function($$v) {
        _vm.compareMonth = $$v
      },
      expression: "compareMonth"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter-group"
  }, [_c('label', [_vm._v("酒类类型")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "全部类型"
    },
    model: {
      value: (_vm.alcoholType),
      callback: function($$v) {
        _vm.alcoholType = $$v
      },
      expression: "alcoholType"
    }
  }, _vm._l((_vm.alcoholTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "action-buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getData
    }
  }, [_vm._v("\n            查询\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-refresh"
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("\n            重置\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "icon": "el-icon-data-line",
      "loading": _vm.compareLoading
    },
    on: {
      "click": _vm.toggleCompare
    }
  }, [_vm._v("\n            " + _vm._s(_vm.enableCompare ? '取消对比' : '数据对比') + "\n          ")])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "overview-section"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('summary-card', {
    attrs: {
      "title": "总销售额",
      "value": _vm.summary.totalAmount,
      "compare-value": _vm.enableCompare ? _vm.compareSummary.totalAmount : null,
      "show-compare": _vm.enableCompare,
      "compare-label": _vm.enableCompare ? _vm.formatCompareTime(_vm.compareTime) : '',
      "unit": "元",
      "icon": "el-icon-money",
      "color": "#67C23A"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('summary-card', {
    attrs: {
      "title": "总销售量",
      "value": _vm.summary.totalSales,
      "compare-value": _vm.enableCompare ? _vm.compareSummary.totalSales : null,
      "show-compare": _vm.enableCompare,
      "compare-label": _vm.enableCompare ? _vm.formatCompareTime(_vm.compareTime) : '',
      "unit": "箱",
      "icon": "el-icon-shopping-bag-1",
      "color": "#409EFF"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('summary-card', {
    attrs: {
      "title": "订单数量",
      "value": _vm.summary.orderCount,
      "compare-value": _vm.enableCompare ? _vm.compareSummary.orderCount : null,
      "show-compare": _vm.enableCompare,
      "compare-label": _vm.enableCompare ? _vm.formatCompareTime(_vm.compareTime) : '',
      "unit": "笔",
      "icon": "el-icon-tickets",
      "color": "#E6A23C"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('summary-card', {
    attrs: {
      "title": "累计客户",
      "value": _vm.summary.customerCount,
      "compare-value": _vm.enableCompare ? _vm.compareSummary.customerCount : null,
      "show-compare": _vm.enableCompare,
      "compare-label": _vm.enableCompare ? _vm.formatCompareTime(_vm.compareTime) : '',
      "unit": "人",
      "icon": "el-icon-user",
      "color": "#F56C6C"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-section"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "main-chart-card"
  }, [_c('div', {
    staticClass: "chart-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.reportType === 'year' ? '年度' : '月度') + "销售趋势")]), _vm._v(" "), _c('div', {
    staticClass: "chart-actions"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.trendChartType),
      callback: function($$v) {
        _vm.trendChartType = $$v
      },
      expression: "trendChartType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "amount"
    }
  }, [_vm._v("销售额")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "sales"
    }
  }, [_vm._v("销售量")])], 1)], 1)]), _vm._v(" "), _c('trend-chart', {
    attrs: {
      "report-type": _vm.reportType,
      "chart-type": _vm.trendChartType,
      "trend-data": _vm.trendData,
      "compare-trend-data": _vm.compareTrendData,
      "enable-compare": _vm.enableCompare,
      "selected-time": _vm.reportType === 'year' ? _vm.selectedYear : _vm.selectedMonth,
      "compare-time": _vm.reportType === 'year' ? _vm.compareYear : _vm.compareMonth
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "chart-row",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "sub-chart-card"
  }, [_c('div', {
    staticClass: "chart-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("酒类销售占比分析")])]), _vm._v(" "), _c('category-pie-chart', {
    attrs: {
      "category-data": _vm.categoryData
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "sub-chart-card"
  }, [_c('div', {
    staticClass: "chart-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("客户情况分析")])]), _vm._v(" "), _c('category-bar-chart', {
    attrs: {
      "customer-data": _vm.comparisonData
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('product-ranking-table', {
    attrs: {
      "products": _vm.productLists,
      "loading": _vm.listLoading,
      "alcohol-type": _vm.alcoholType
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-581f0084"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataSheet/ProductSales.vue
// module id = 1013
// module chunks = 3